"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
Object.defineProperty(exports, "__esModule", {
    value: true
}); // src/utils/errors.ts
var InvalidUrlError = /*#__PURE__*/ function(Error1) {
    _inherits(InvalidUrlError, Error1);
    var _super = _create_super(InvalidUrlError);
    function InvalidUrlError(message) {
        _class_call_check(this, InvalidUrlError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "InvalidUrlError";
        return _this;
    }
    return InvalidUrlError;
}(_wrap_native_super(Error));
var InvalidStringError = /*#__PURE__*/ function(Error1) {
    _inherits(InvalidStringError, Error1);
    var _super = _create_super(InvalidStringError);
    function InvalidStringError(message) {
        _class_call_check(this, InvalidStringError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "InvalidStringError";
        return _this;
    }
    return InvalidStringError;
}(_wrap_native_super(Error));
var EmptyStringError = /*#__PURE__*/ function(Error1) {
    _inherits(EmptyStringError, Error1);
    var _super = _create_super(EmptyStringError);
    function EmptyStringError(message) {
        _class_call_check(this, EmptyStringError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "EmptyStringError";
        return _this;
    }
    return EmptyStringError;
}(_wrap_native_super(Error));
var UndefinedOrNullError = /*#__PURE__*/ function(Error1) {
    _inherits(UndefinedOrNullError, Error1);
    var _super = _create_super(UndefinedOrNullError);
    function UndefinedOrNullError(message) {
        _class_call_check(this, UndefinedOrNullError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "UndefinedOrNullError";
        return _this;
    }
    return UndefinedOrNullError;
}(_wrap_native_super(Error));
var StringOutOfRangeError = /*#__PURE__*/ function(Error1) {
    _inherits(StringOutOfRangeError, Error1);
    var _super = _create_super(StringOutOfRangeError);
    function StringOutOfRangeError(message) {
        _class_call_check(this, StringOutOfRangeError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "StringOutOfRangeError";
        return _this;
    }
    return StringOutOfRangeError;
}(_wrap_native_super(Error));
var NonceError = /*#__PURE__*/ function(Error1) {
    _inherits(NonceError, Error1);
    var _super = _create_super(NonceError);
    function NonceError(message) {
        _class_call_check(this, NonceError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "NonceError";
        return _this;
    }
    return NonceError;
}(_wrap_native_super(Error));
var CsrfError = /*#__PURE__*/ function(Error1) {
    _inherits(CsrfError, Error1);
    var _super = _create_super(CsrfError);
    function CsrfError(message) {
        _class_call_check(this, CsrfError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "CsrfError";
        return _this;
    }
    return CsrfError;
}(_wrap_native_super(Error));
var InvalidHttpTokenResponseError = /*#__PURE__*/ function(Error1) {
    _inherits(InvalidHttpTokenResponseError, Error1);
    var _super = _create_super(InvalidHttpTokenResponseError);
    function InvalidHttpTokenResponseError(message) {
        _class_call_check(this, InvalidHttpTokenResponseError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "InvalidHttpTokenResponseError";
        return _this;
    }
    return InvalidHttpTokenResponseError;
}(_wrap_native_super(Error));
var InvalidURLSearchParamsError = /*#__PURE__*/ function(Error1) {
    _inherits(InvalidURLSearchParamsError, Error1);
    var _super = _create_super(InvalidURLSearchParamsError);
    function InvalidURLSearchParamsError(message) {
        _class_call_check(this, InvalidURLSearchParamsError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "InvalidURLSearchParamsError";
        return _this;
    }
    return InvalidURLSearchParamsError;
}(_wrap_native_super(Error));
var MissingSearchCodeParamError = /*#__PURE__*/ function(Error1) {
    _inherits(MissingSearchCodeParamError, Error1);
    var _super = _create_super(MissingSearchCodeParamError);
    function MissingSearchCodeParamError(message) {
        _class_call_check(this, MissingSearchCodeParamError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "MissingSearchCodeParamError";
        return _this;
    }
    return MissingSearchCodeParamError;
}(_wrap_native_super(Error));
var MissingSearchStateParamError = /*#__PURE__*/ function(Error1) {
    _inherits(MissingSearchStateParamError, Error1);
    var _super = _create_super(MissingSearchStateParamError);
    function MissingSearchStateParamError(message) {
        _class_call_check(this, MissingSearchStateParamError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "MissingSearchStateParamError";
        return _this;
    }
    return MissingSearchStateParamError;
}(_wrap_native_super(Error));
var AuthCodeNotFoundError = /*#__PURE__*/ function(Error1) {
    _inherits(AuthCodeNotFoundError, Error1);
    var _super = _create_super(AuthCodeNotFoundError);
    function AuthCodeNotFoundError(message) {
        _class_call_check(this, AuthCodeNotFoundError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "AuthCodeNotFoundError";
        return _this;
    }
    return AuthCodeNotFoundError;
}(_wrap_native_super(Error));
var CsrfNotFoundError = /*#__PURE__*/ function(Error1) {
    _inherits(CsrfNotFoundError, Error1);
    var _super = _create_super(CsrfNotFoundError);
    function CsrfNotFoundError(message) {
        _class_call_check(this, CsrfNotFoundError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "CsrfNotFoundError";
        return _this;
    }
    return CsrfNotFoundError;
}(_wrap_native_super(Error));
var GetProfileResponseError = /*#__PURE__*/ function(Error1) {
    _inherits(GetProfileResponseError, Error1);
    var _super = _create_super(GetProfileResponseError);
    function GetProfileResponseError(message) {
        _class_call_check(this, GetProfileResponseError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "GetProfileResponseError";
        return _this;
    }
    return GetProfileResponseError;
}(_wrap_native_super(Error));
var DecodeJwtError = /*#__PURE__*/ function(Error1) {
    _inherits(_DecodeJwtError, Error1);
    var _super = _create_super(_DecodeJwtError);
    function _DecodeJwtError(message) {
        _class_call_check(this, _DecodeJwtError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "DecodeJwtError";
        Error.captureStackTrace(_assert_this_initialized(_this), _DecodeJwtError);
        return _this;
    }
    return _DecodeJwtError;
}(_wrap_native_super(Error));
var JwtValidationError = /*#__PURE__*/ function(Error1) {
    _inherits(_JwtValidationError, Error1);
    var _super = _create_super(_JwtValidationError);
    function _JwtValidationError(message) {
        _class_call_check(this, _JwtValidationError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "JwtValidationError";
        Error.captureStackTrace(_assert_this_initialized(_this), _JwtValidationError);
        return _this;
    }
    return _JwtValidationError;
}(_wrap_native_super(Error));
var StatusCode1xxError = /*#__PURE__*/ function(Error1) {
    _inherits(StatusCode1xxError, Error1);
    var _super = _create_super(StatusCode1xxError);
    function StatusCode1xxError(message) {
        _class_call_check(this, StatusCode1xxError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "StatusCode1xxError";
        return _this;
    }
    return StatusCode1xxError;
}(_wrap_native_super(Error));
var StatusCode3xxError = /*#__PURE__*/ function(Error1) {
    _inherits(StatusCode3xxError, Error1);
    var _super = _create_super(StatusCode3xxError);
    function StatusCode3xxError(message) {
        _class_call_check(this, StatusCode3xxError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "StatusCode3xxError";
        return _this;
    }
    return StatusCode3xxError;
}(_wrap_native_super(Error));
var StatusCode4xxError = /*#__PURE__*/ function(Error1) {
    _inherits(StatusCode4xxError, Error1);
    var _super = _create_super(StatusCode4xxError);
    function StatusCode4xxError(message) {
        _class_call_check(this, StatusCode4xxError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "StatusCode4xxError";
        return _this;
    }
    return StatusCode4xxError;
}(_wrap_native_super(Error));
var StatusCode5xxError = /*#__PURE__*/ function(Error1) {
    _inherits(StatusCode5xxError, Error1);
    var _super = _create_super(StatusCode5xxError);
    function StatusCode5xxError(message) {
        _class_call_check(this, StatusCode5xxError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "StatusCode5xxError";
        return _this;
    }
    return StatusCode5xxError;
}(_wrap_native_super(Error));
var EnvironmentNotGivenError = /*#__PURE__*/ function(Error1) {
    _inherits(EnvironmentNotGivenError, Error1);
    var _super = _create_super(EnvironmentNotGivenError);
    function EnvironmentNotGivenError(message) {
        _class_call_check(this, EnvironmentNotGivenError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "EnvironmentNotGivenError";
        return _this;
    }
    return EnvironmentNotGivenError;
}(_wrap_native_super(Error));
exports.InvalidUrlError = InvalidUrlError;
exports.InvalidStringError = InvalidStringError;
exports.EmptyStringError = EmptyStringError;
exports.UndefinedOrNullError = UndefinedOrNullError;
exports.StringOutOfRangeError = StringOutOfRangeError;
exports.NonceError = NonceError;
exports.CsrfError = CsrfError;
exports.InvalidHttpTokenResponseError = InvalidHttpTokenResponseError;
exports.InvalidURLSearchParamsError = InvalidURLSearchParamsError;
exports.MissingSearchCodeParamError = MissingSearchCodeParamError;
exports.MissingSearchStateParamError = MissingSearchStateParamError;
exports.AuthCodeNotFoundError = AuthCodeNotFoundError;
exports.CsrfNotFoundError = CsrfNotFoundError;
exports.GetProfileResponseError = GetProfileResponseError;
exports.DecodeJwtError = DecodeJwtError;
exports.JwtValidationError = JwtValidationError;
exports.StatusCode1xxError = StatusCode1xxError;
exports.StatusCode3xxError = StatusCode3xxError;
exports.StatusCode4xxError = StatusCode4xxError;
exports.StatusCode5xxError = StatusCode5xxError;
exports.EnvironmentNotGivenError = EnvironmentNotGivenError;
